"use strict";

$(window).on("load", function () {

    if ($("#promotionModal").attr("data-show") === "true") {
        $("#promotionModal").modal("show");
    }

});
